var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasDownloadLogId
    ? _c(
        "el-button",
        {
          staticClass: "handle-view",
          attrs: {
            type: "info",
            size: "small",
            disabled: _vm.loading || _vm.disabled,
          },
          on: { click: _vm.download },
        },
        [_vm._v("\n  " + _vm._s(_vm.loading ? "Loading..." : _vm.label) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }